import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from '../shared/request.service';

@Component({
  selector: 'app-request-success',
  templateUrl: './request-success.component.html',
  styleUrls: ['./request-success.component.scss']
})
export class RequestSuccessComponent implements OnInit {

  typeRequest: number;
  documents: DocumentType[];
  isRegular = true;
  tittleDocument = 'Recuerde la documentación requerida para entregar en la unidad académica';

  constructor(private route: ActivatedRoute, private requestService: RequestService, private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(
      (params) => {
        this.typeRequest = params['tipo'];
        if (this.typeRequest > 2) {
          this.isRegular = false;
          this.tittleDocument = 'Recuerde';
        }
        this.getListDocumentRequiered(this.typeRequest + '');
      }
    );
  }

  private getListDocumentRequiered(tipo: String) {
    this.requestService.getTypesDocument(tipo).subscribe(
      (result) => {
        if (result.data !== {}) {
          this.tittleDocument = result.data.titulo;
          this.documents = result.data.documentos  as DocumentType[];
        }
     }
    );
  }

  back() {
    this.router.navigate(['solicitudes']);
  }
}
